import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { AuthenticationGuard } from '@app/auth/authentication.guard';
import { ErrorPageComponent } from '@app/error-page/error-page.component';

import { Shell } from '@app/shell/shell.service';

const routes: Routes = [
  // Auth routes (login, logout, etc.) - accessible without authentication
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  
  // Redirect auth sub-routes to root level
  { path: 'login', redirectTo: '/auth/login', pathMatch: 'full' },
  { path: 'logout', redirectTo: '/auth/logout', pathMatch: 'full' },
  { path: 'forgot-pwd', redirectTo: '/auth/forgot-pwd', pathMatch: 'full' },
  { path: 'reset-pwd', redirectTo: '/auth/reset-pwd', pathMatch: 'full' },
  { path: 'change-password', redirectTo: '/auth/change-password', pathMatch: 'full' },
  
  // Standalone error pages (without shell) - MUST come before shell routes
  {
    path: 'error',
    component: ErrorPageComponent,
    data: { title: 'Fehler' },
  },
  {
    path: 'error-404',
    component: ErrorPageComponent,
    data: { title: 'Fehler 404' },
  },
  {
    path: '404',
    component: ErrorPageComponent,
    data: { title: 'Fehler 404' },
  },
  {
    path: 'fdsa',
    redirectTo: '/error-404',
    pathMatch: 'full'
  },
  
  // Default route redirect to reports (will be handled by AuthenticationGuard)
  { path: '', redirectTo: '/reports', pathMatch: 'full' },
  
  Shell.childRoutes([
    // Lazy-loaded routes moved to shell-routing.module.ts
  ]),

  // Fallback when no prior route is matched - redirect to error page
  { path: '**', redirectTo: '/error-404', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}

